<div class="custom-toggle normal" [ngClass]="{'checked': Value==1, 'unchecked': Value==2}"  (click)="changeValue()"></div>
